var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M10.0003 18.3337C14.6027 18.3337 18.3337 14.6027 18.3337 10.0003C18.3337 5.39795 14.6027 1.66699 10.0003 1.66699C5.39795 1.66699 1.66699 5.39795 1.66699 10.0003C1.66699 14.6027 5.39795 18.3337 10.0003 18.3337Z",
    fill: "#8392A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0919 13.2755C12.9835 13.2755 12.8752 13.2505 12.7752 13.1838L10.1919 11.6421C9.55019 11.2588 9.0752 10.4171 9.0752 9.67546V6.25879C9.0752 5.91712 9.35853 5.63379 9.7002 5.63379C10.0419 5.63379 10.3252 5.91712 10.3252 6.25879V9.67546C10.3252 9.97546 10.5752 10.4171 10.8335 10.5671L13.4169 12.1088C13.7169 12.2838 13.8085 12.6671 13.6335 12.9671C13.5085 13.1671 13.3002 13.2755 13.0919 13.2755Z",
    fill: "#8392A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.c8c78c94386945d23eaf3e5dbf68046f.svg";
export { ForwardRef as ReactComponent };